<template>
  <div class="base-left">
    <p>{{$i18n.t('aswTitle')}}</p>
    <p class="f16"><span v-html="$i18n.t('aswDesc')"></span><span class="link" @click="link">{{lang === 'zh'?'请与我们联系。':'please contact us.'}}</span></p>
    <p class="last">{{$i18n.t('readMore')}}</p>
  </div>
</template>
<script>
import { setup } from '@/widgets/i18n'
export default {
  computed: {
  },
  data() {
    return {
      lang: 'zh'
    }
  },
  methods: {
    changeL(lang) {
      this.lang = lang
      setup(lang)
    },
    link() {
      let url = this.lang === 'zh' ? 'https://www.aiswei-tech.com/contact.html' : 'https://en.aiswei-tech.com/contact.html'
      window.open(url)
    }
  },
  created() {
    this.lang = window.localStorage.getItem('localeLanguage') || 'zh'
  }
}
</script>
<style lang="stylus">
.base-left
  width 375px
  float left
  padding-top 60px
  padding-right 10px
  p
    color #666666
    font-size 18px
    font-weight bold
    margin-bottom 13px
    line-height 100%
  .f16
    font-weight normal
    margin-bottom 40px
    font-size 16px
  .last
    color #EA5413   
    font-size 16px 
  .link
    color #409eff
    text-decoration underline
    cursor pointer
</style>


// WEBPACK FOOTER //
// src/modules/baseLeft/index.vue